import { IGrid, IGridConfig } from "@dhx/ts-grid";
import { DataPage } from "@xbs/muon";
import { getFormattedValue } from "./format";
import { getCellIds, getCellInfo, getLetterFromNumber, getTextHeight } from "./main";
import { Id } from "@dhx/ts-common/types";
import { IFormats, ISpan } from "../types";
declare const dhx: any;

export function getHeaderCell(letter: string, index: number): string {
	return `<div class="dhx_custom_header_cell">
			${letter}
		<div class="dhx_resizer_grip_wrap">
			<div class="dhx_resizer_grip" data-dhx-id=${index}>
				<div class="dhx_resizer_grip_line"></div>
			</div>
		</div>
		<i class="dxi dxi-dots-vertical dhx_header_icon" data-dhx-id=${index}></i>
	</div>`;
}

export function getIndexRowCell(index: number): string {
	return `<div class="dhx_custom_index_cell">${index}
	<div class="dhx_resizer_grip_wrap">
			<div class="dhx_resizer_grip" data-dhx-id=${index - 1}>
				<div class="dhx_resizer_grip_line"></div>
			</div>
		</div>
	</div>`;
}

export function updateColumns(config: IGridConfig) {
	const columns = config.columns;
	let totalWidth = 0;
	columns?.map((col: any, i) => {
		col.width = col.width || 120;

		totalWidth += col.hidden ? 0 : col.width;
		if (col.id !== "$index") {
			const letter = getLetterFromNumber(i);
			col.header = [
				{
					text: getHeaderCell(letter, i),
					css: "",
				},
			];
			col.$letter = letter;
		}
	});
	config.$totalWidth = totalWidth;
}

export function updateRowsIndex(data) {
	data.map((row, i) => {
		row.$index = i + 1;
	});
}

export function removeRowsCss(grid: IGrid) {
	grid.data.map(row => {
		grid.removeRowCss(row.id as Id, "dhx_selected_row");
	});
}

export function setAutoHeightToRow(
	cell: string,
	grid: IGrid,
	page: DataPage,
	multiline: string
): boolean | undefined {
	const { cols, rows } = page.getMeta();
	const { row, col } = getCellIds(cell, grid);
	const wrap = multiline === "wrap";
	const cellMeta = getCellInfo(cell, page, grid);
	const rowMeta = rows[row]
	const { value, format } = cellMeta;
	if (!value) return;
	const formated_value = getFormattedValue(value, format as IFormats);
	const colWidth = cols[col]?.width;
	const text_height = getTextHeight(formated_value, colWidth);
	rowMeta.wrap = (rowMeta.wrap || 0) + (wrap ? 1 : -1);
	rows[row] = { ...rowMeta };
	page.setMeta({ rows });

	// return if height of row was changed by user
	if (rows[row]?.changedByUser) return;

	// return if it's wrapp and new height less than current height
	if (wrap && text_height <= rows[row].height) {
		return;
	}

	// 	// return if it's overflow and row has items with wrapp
	if (!wrap && rowMeta.wrap) return;

	rows[row] = { ...rowMeta, height: wrap ? text_height : grid.config.rowHeight };
	page.setMeta({ rows });
	return true;
}

export function updateSpans(dc: number, dr: number, index: number, page: DataPage): ISpan[] | undefined {
	const { merged } = page.getMeta();
	if (!merged?.length) return;
	let changed = false;
	const spans = (merged as ISpan[]).map(({ from, to }) => {
		// update by col
		if (dc) {
			if (from.column >= index || to.column >= index) {
				const newFrom = { ...from };
				const newSpan = {
					from: newFrom,
					to: { ...to, column: to.column + dc },
				};
				// check that from column is not the deleted column
				if ((from.column >= index && dc > 0) || (from.column > index && dc < 0)) {
					const col = newFrom.column;
					newFrom.column = col + dc < 0 ? 0 : col + dc;
				}
				changed = true;
				return newSpan;
			}
		}

		//update by row
		if (dr) {
			if (from.row >= index || to.row >= index) {
				const newFrom = { ...from };
				const newSpan = {
					from: newFrom,
					to: { ...to, row: to.row + dr },
				};
				if ((from.row >= index && dr > 0) || (from.column > index && dr < 0)) {
					const row = newFrom.row;
					newFrom.row = row + dr < 0 ? 0 : row + dr;
				}
				changed = true;
				return newSpan;
			}
		}

		return { from, to };
	});
	if (!changed) return;
	page.setMeta({ merged: spans });
	return spans;
}
